(ns frontend.view.nev.events
  (:require
   [frontend.state.current-session :as session]
   [frontend.subscription :as subscription]
   [potpuri.core :as potpuri :refer [fn-> fn->> dissoc-in]]
   [frontend.logging :as logging]
   [frontend.actions.account :as account-actions]
   [frontend.utils :as fu]
   [reagent.core :as r]))

(defn save-modules-order!
  [entity-type view-id ordering on-success! on-error!]
  (let [msg {:path      [view-id :modules :ordering]
             :new-value ordering}]
    (account-actions/*->update-view-config
     msg
     (or on-success! identity)
     (or on-error!
         (fn [e]
           (logging/error "Unable to save modules order" e))))))

(defn save-module-collapsed!
  [entity-type view-id module-id collapsed? on-success! on-error!]
  (let [msg {:path      [view-id :modules :module-config module-id :collapsed?]
             :new-value collapsed?}]
    (account-actions/*->update-view-config
     msg
     (or on-success! identity)
     (or on-error!
         (fn [e]
           (logging/error "Unable to save module collapsed" e))))))

(defn set-temp!
  [temp-atom path value]
  (swap! temp-atom assoc-in path value)
  @temp-atom)

(defn empty-temp!
  [temp-atom path]
  (swap! temp-atom dissoc-in path)
  @temp-atom)

(defn show-error!
  [error-atom content]
  (reset! error-atom content)
  @error-atom)

(defn show-notification!
  [notification-atom content]
  (reset! notification-atom content)
  @notification-atom)


(defn clear-errors!
  [error-atom notification-atom]
  (when error-atom
    (reset! error-atom nil)
    @error-atom)
  (when notification-atom
    (reset! notification-atom nil)
    @notification-atom))

;; spiking temp-timeout:
(defonce temp-values-atom (r/atom {}))
(defonce timeouts (atom {}))

(defn timeout-value
  [timeout-id value]
  (let [temp-values @temp-values-atom]
    (if (contains? temp-values timeout-id)
      (get temp-values timeout-id)
      value)))
;;can probably be generalized (wrap-save timeout-id params on-success! on-error!)
;;-session/entities - wrap whole entity-atom in a reaction that returns (merge @entity-atom @temp-atom)
;;                    => can be used as the entity-atom
(defn save-field-defs!
  [timeout-id path field-defs on-success! on-error!]
  (let [msg {:path      path
             :new-value field-defs}
        old-timeout (get @timeouts timeout-id)]
    (when old-timeout
      (js/clearTimeout old-timeout)
      (swap! timeouts dissoc timeout-id))
    (swap! temp-values-atom assoc timeout-id field-defs)
    ;;note: later release: (likely) named-views to allow multiple views + sharing:
    (account-actions/*->update-view-config
     msg
     (fn []
       (let [old-timeout (get @timeouts timeout-id)]
         (when old-timeout
           (js/clearTimeout old-timeout)))
       (when (fn? on-success!)
         (on-success!))
       (let [new-timeout (fu/timeout
                          1000
                          (fn [_]
                            (swap! timeouts dissoc timeout-id)
                            (swap! temp-values-atom dissoc timeout-id)))]
         (swap! timeouts assoc timeout-id new-timeout)))
     (fn [err]
       (swap! temp-values-atom dissoc timeout-id)
       (on-error! err)))))

(defn updates-to-session-state
  [entities]
  (fu/manage-entities session/reverse-lookup
                      session/session
                      entities))

(defn subscribe-to-changes!
  [{:keys [entity opts on-updates!]}]
  (subscription/open ::entity-updates
                     :entity-updates
                     {:entity-id (:db/id entity)
                      :opts      opts}
                     (fn [{:keys [entities]}]
                       (when (fn? on-updates!)
                         (on-updates! entities))
                       :ok)))

(defn unsubscribe-changes!
  [{:keys [entity]}]
  (subscription/close ::entity-updates))
